import { render, staticRenderFns } from "./view-visit.vue?vue&type=template&id=7c0ca58c&scoped=true"
import script from "./view-visit.vue?vue&type=script&lang=js"
export * from "./view-visit.vue?vue&type=script&lang=js"
import style0 from "./view-visit.vue?vue&type=style&index=0&id=7c0ca58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0ca58c",
  null
  
)

export default component.exports